import React, { useCallback } from 'react';
import type OrderItemTodo from '@this/src/domain/arrangement/order_item_todo';
import { Button } from '@this/src/components/shared/ui/inputs/button';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@this/src/components/shared/ui/feedbacks/modal';

interface Props {
  todo: OrderItemTodo | null;
  onClose: () => void;
  onAbort: (todo: OrderItemTodo) => void;
}

const OrderItemSequenceAbortConfirm: React.FC<Props> = ({ todo, onClose, onAbort }) => {
  const handleSubmit = useCallback(() => {
    if (todo) onAbort(todo);
    onClose();
  }, [todo, onAbort]);

  return (
    <Modal open={Boolean(todo)} size="medium" onClose={onClose}>
      <ModalHeader>シーケンスの破棄</ModalHeader>
      <ModalBody>
        <p>進行しているステップをすべて破棄してシーケンスを終了しますか？</p>
      </ModalBody>
      <ModalFooter>
        <Button color="sub" onClick={onClose}>
          キャンセル
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          破棄
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OrderItemSequenceAbortConfirm;
